import { UserState } from './types';

export const customerIdSelector = (state): UserState['currentCompany'] => state.user.currentCompany;
